/**
 * usePlayBlocks Hook
 *
 * Core hook for managing play state with React Query.
 * Replaces PlayContext with server-state management.
 */

// Main hook export
export { usePlayBlocks } from './UsePlayBlocks'
export { getResolvedBlockQueryKey } from '@/hooks/UseResolvedBlock'

// Mutations hook
export { usePlayMutations, createPlaceholderMutations } from './UsePlayMutations'
export type { UsePlayMutationsOptions } from './UsePlayMutations'

// Save status (shared context, re-exported for convenience)
export { SaveStatusProvider, useSaveStatus } from '@/contexts/SaveStatusContext'
export type { SaveStatus } from '@/contexts/SaveStatusContext'

// Session snapshot
export { useSessionSnapshot } from './UseSessionSnapshot'

// Types
export type {
	UsePlayBlocksOptions,
	UsePlayBlocksReturn,
	PlayBlockMutations,
} from './Types'

export {
	DEFAULT_DRAWING_STATE,
	DEFAULT_HASH_ALIGNMENT,
} from './Types'
